
import { computed, defineComponent, ref, Ref } from 'vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import { useSharing } from '@/core/SoMe/sharing.composable';
import wishListsStore from '../wish-lists.store';
import ClipboardCopy from '@/b2c/shared/ClipboardCopy.vue';
import BaseDialog from '@/shared/dialog/BaseDialog.vue';

export default defineComponent({
    name: 'WishListShareButton',
    components: { BaseDialog, ClipboardCopy },
    props: {
        shareUrl: {
            type: String,
            required: true,
        },
        shareImage: {
            type: String,
            required: false,
            default: undefined,
        },
    },
    setup() {
        const labels = useBlockLabels();
        const { emailShareLink, pinterestShareLink, openFacebookShareWindow } = useSharing();
        const showDefaultWishListShare: Ref<boolean> = ref(false);

        const details = computed(() => {
            return wishListsStore.details;
        });

        const toggleWishListDialogue = () => {
            showDefaultWishListShare.value = !showDefaultWishListShare.value;
        };

        return {
            labels,
            details,
            emailShareLink,
            pinterestShareLink,
            openFacebookShareWindow,
            showDefaultWishListShare,
            toggleWishListDialogue,
        };
    },
});
